<div class="content-wrapper" [appTooltip]="locked() ? lockedMessage() : ''" [tooltipDisabled]="!locked()">
  <ng-content></ng-content>
  @if (locked()) {
    <span class="visually-hidden">({{ lockedMessage() }})</span>
  }
</div>
@if (locked()) {
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="lock-icon" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
  </svg>
}
@if (selected() !== null) {
  <svg class="check-icon" [class.check-icon--on]="selected()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
  </svg>
}
